module.exports = __webpack_public_path__ + "static/nlp-3627d7babfca14e7be671a5b707c549c.jpg";